const getDaysUntilEvent = (eventDate: string) => {
  return Math.abs(Math.round((new Date(eventDate).getTime() - Date.now()) / (1000 * 60 * 60 * 24)))
}

export default getDaysUntilEvent
